import tw from "twin.macro";
export const StyledDiv = tw.div`font-display min-h-screen text-secondary-500 p-8 overflow-hidden`;
